import { AuthenticatedContext } from '@sec-loans-ui/common/types'
import { RootWizard } from '@sec-loans-ui/common/wizard/RootWizard'
import { AppId } from '@shared/types'
import { CommonBankApp } from '@ui-common/components/CommonBankApp'
import { JSX } from 'react'

import { messages } from './l10n/messages'
import { SecLoansAnalyticsContextProvider } from './state/analyticsContext'

interface AppProps {
  authenticatedState?: AuthenticatedContext
}

const App = ({ authenticatedState }: AppProps): JSX.Element => {
  return (
    <CommonBankApp appId={AppId.SecLoans} translations={messages}>
      <SecLoansAnalyticsContextProvider>
        <RootWizard authenticatedContext={authenticatedState} />
      </SecLoansAnalyticsContextProvider>
    </CommonBankApp>
  )
}

export default App
